import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ProcessService } from '@shared/service/process.service';
import { AIRMasterDTO } from 'app/model/air-master-dto';
import { AirMasterService } from 'app/service/air-master.service';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-add-process-department',
  templateUrl: './add-process-department.component.html',
  styleUrls: ['./add-process-department.component.scss'],
})
export class AddProcessDepartmentComponent implements OnInit {
  selectedDepartment: string;
  selectedSection: string;
  showBlock = '';
  airDto = new AIRMasterDTO();
  parsedJson: any;

  @Output() closePanel: EventEmitter<boolean> = new EventEmitter();

  @Output() save: EventEmitter<boolean> = new EventEmitter();

  airItemAddForm: FormGroup = this.builder.group({
    departmentName: '',
    airItemName: '',
    attachmentReq: '',
  });

  departments = [
    { value: 'admin', label: 'Adminstration' },
    { value: 'HR', label: 'Human Resources' },
    { value: 'finance', label: 'Finance' },
  ];

  sections = [
    { value: 'security', label: 'Security' },
    { value: 'housekeeping', label: 'House keeping services' },
    { value: 'Canteen Services', label: 'Canteen Services' },
  ];

  constructor(
    private processService: ProcessService,
    private airMasterService: AirMasterService,
    private builder: FormBuilder
  ) {}

  ngOnInit() {
    this.processService.getProcess().subscribe(data => {
      this.showBlock = data;
    });
  }
  closed() {
    this.closePanel.emit(false);
  }
  saveAIRItem() {
    this.save.emit(true);
  }
  addAIRItem() {
    this.airDto.departmentId = '34';
    this.airDto.airItemName = this.airItemAddForm.get('airItemName').value;
    //  this.airDto.isAttachmentRequired="1";
    if (this.airItemAddForm.get('attachmentReq').value) {
      this.airDto.isAttachmentRequired = '1';
    } else {
      this.airDto.isAttachmentRequired = '0';
    }
    this.airDto.createdBy = '1';
    this.airDto.templateId = '6';

    this.airMasterService.createAIRItem(this.airDto).subscribe(
      data => {
        // this.parsedJson = JSON.parse(JSON.stringify(data));
      },
      error => {}
    );
  }
}
